import type { FourCsKeyConfig } from './four-cs-widget.types';
import { i18n } from '@/shared/i18n';

// Getters, not values: this array is built while the module is evaluated, so resolving per
// read is what lets the copy follow a language change instead of freezing at import.
export const FOUR_CS_KEYS: readonly FourCsKeyConfig[] = [
  {
    key: 'category',
    get label() {
      return i18n.t('analysis:fourCsWidget.fourCs.category');
    },
  },
  {
    key: 'consumer',
    get label() {
      return i18n.t('analysis:fourCsWidget.fourCs.consumer');
    },
  },
  {
    key: 'company',
    get label() {
      return i18n.t('analysis:fourCsWidget.fourCs.company');
    },
  },
  {
    key: 'cultural',
    get label() {
      return i18n.t('analysis:fourCsWidget.fourCs.cultural');
    },
  },
];
